import React, { useEffect } from 'react';

interface Props {
  selectedLabel?: string;
  nonSelectedLabel?: string;
  selectedList: any;
  nonSelectedList: any;
  setSelectedList: any;
  setNonSelectedList: any;
  userSetting?: any;
}

const MultiSelectContainer = ({
  selectedLabel,
  nonSelectedLabel,
  selectedList,
  nonSelectedList,
  setSelectedList,
  setNonSelectedList,
  userSetting,
}: Props) => {
  let checkboxChangeFlag = false;

  function handleCheckboxChange(item: any, checked: boolean) {
    if (!checkboxChangeFlag) {
      checkboxChangeFlag = true;

      if (checked) {
        // Only move the item to the selected list if it's not already there
        if (!selectedList.find((i: any) => i.id === item.id)) {
          handleAction(item, 'toSelectedList');
        }
      } else {
        // Only move the item to the non-selected list if it's not already there
        if (!nonSelectedList.find((i: any) => i.id === item.id)) {
          handleAction(item, 'toNonSelectedList');
        }
      }

      // Reset the flag after handling the change
      setTimeout(() => {
        checkboxChangeFlag = false;
      }, 0);
    }
  }

  function handleAction(item: any, list: string) {
    if (list === 'toSelectedList') {
      const updatedNonSelectedList = nonSelectedList.filter(
        (i: any) => i.id !== item.id
      );
      const updatedSelectedList = [...selectedList, item];

      setNonSelectedList(updatedNonSelectedList);
      setSelectedList(updatedSelectedList);
    } else {
      const updatedSelectedList = selectedList.filter(
        (i: any) => i.id !== item.id
      );
      const updatedNonSelectedList = [...nonSelectedList, item];

      setSelectedList(updatedSelectedList);
      setNonSelectedList(updatedNonSelectedList);
    }
  }
  useEffect(() => {}, [selectedList, nonSelectedList]);
  return (
    <div>
      <div className='row mb-0'>
        <div
          className={
            userSetting || nonSelectedLabel ? 'col-5 mb-0' : 'col-4 mb-0'
          }
        >
          <p
            className={
              nonSelectedLabel ? 'globalInputLabel' : 'globalInputLabel '
            }
          >
            {' '}
            {nonSelectedLabel ? nonSelectedLabel : 'Available Carriers'}
          </p>
          {/* <label>{nonSelectedLabel && nonSelectedLabel}</label> */}
        </div>
        <div
          className={
            userSetting || nonSelectedLabel ? 'col-5 mb-0' : 'col-4 mb-0'
          }
        >
          <p
            className={
              userSetting
                ? 'pl-5 ms-4 globalInputLabel mb-0'
                : 'globalInputLabel mb-0 pl-4 ms-4'
            }
          >
            {selectedLabel ? selectedLabel : 'Selected Carriers'}
          </p>
          {/* <label className='pl-4 ms-4'>{selectedLabel && selectedLabel}</label> */}
        </div>
      </div>
      <div
        className={
          nonSelectedLabel || userSetting
            ? ' d-flex gap-3 w-100-imp ms-container '
            : 'ms-container d-flex gap-3'
        }
        id='ms-permission_select'
      >
        <div className='ms-selectable borderblack'>
          <ul
            className='ms-list p-1'
            tabIndex={-1}
          >
            {nonSelectedList &&
              nonSelectedList.length > 0 &&
              nonSelectedList.map((item: any) => (
                <div className='form-check cursor-pointer itemMuliple'>
                  <input
                    className='form-check-input globalInputLabel mb-1 ms-1'
                    type='checkbox'
                    id={`${item.id}-selectable`}
                    checked={false}
                    onChange={(e) => {
                      e.stopPropagation();
                      handleCheckboxChange(item, true);

                      // handleCheckboxChange(item, e.target.checked);
                    }}
                  />

                  <label
                    className='form-check-label globalInputLabel'
                    style={{
                      fontWeight: '300',
                      cursor: 'pointer',
                      marginTop: '1.5px',
                    }}
                    htmlFor={`${item.id}-selectable`}
                    onClick={(e) => e.stopPropagation()} // Stop propagation from label to div
                  >
                    {item.name}
                  </label>
                </div>
              ))}
          </ul>
          <p className='tooltip-text mx-1 p-2 Btop mb-0'>
            {nonSelectedList?.length ? nonSelectedList?.length : 0} Available
          </p>
        </div>
        <div className='ms-selection borderblack'>
          <ul
            className='ms-list p-1'
            tabIndex={-1}
          >
            {selectedList &&
              selectedList.length > 0 &&
              selectedList.map((item: any) => (
                <div className='form-check cursor-pointer  itemMuliple'>
                  <input
                    className='form-check-input globalInputLabel mb-1 ms-1'
                    type='checkbox'
                    id={`${item.id}-selection`}
                    checked={true}
                    onChange={(e) => {
                      e.stopPropagation();
                      handleCheckboxChange(item, false);
                      // handleCheckboxChange(item, e.target.checked);
                    }}
                  />
                  <label
                    className='form-check-label globalInputLabel'
                    style={{ fontWeight: '300', cursor: 'pointer' }}
                    htmlFor={`${item.id}-selection`}
                    onClick={(e) => e.stopPropagation()} // Stop propagation from label to div
                  >
                    {item.name}
                  </label>
                </div>
              ))}
          </ul>
          <p className='tooltip-text mx-1 p-2 Btop mb-0'>
            {' '}
            {selectedList?.length ? selectedList?.length : 0} Selected
          </p>
        </div>
      </div>
    </div>
  );
};

export default MultiSelectContainer;
